module.exports = __webpack_public_path__ + "static/Original Logo-55adc4cab91ba4d162c74ec629406437.png";